Vendd.Scripts.load(function () {
    'use strict';

    var $wrapper = $('.x-shared-list'), wrapper;

    if ($wrapper.length < 1) return;

    wrapper = $wrapper.get(0);

    var model = null;
    var itemsCount = $('.shared-list-item', $wrapper).length;
    var selectedItems = $('[data-type="selectCheckbox"]:checked').length;

    var $fancyboxCartLink = $('.cart-confirmation-fancybox');
    $fancyboxCartLink.fancybox({ type: 'inline' });

    var $fancyboxWishlistLink = $('.wishlist-confirmation-fancybox');
    $fancyboxWishlistLink.fancybox({ type: 'inline' });

    wrapper.loading = function loading(loading) {
        if (loading) {
            $wrapper.addClass('x-loading');
        } else {
            $wrapper.removeClass('x-loading');
        };
    };

    wrapper.update = function () {
        wrapper.loading(true);

        var html = Vendd.Handlebars.parse("sharedList_A", model);
        wrapper.bind(html);

        //init sticky navigation bar
        //toggleStickyNavigationBar();

        wrapper.loading(false);
    };

    wrapper.bind = function bind(html) {
        $wrapper.html(html);
    };

    wrapper.updateButtons = function () {
        if (selectedItems > 0) {
            if ($('.add-selected-to-cart', $wrapper).hasClass('disabled'))
                $('.add-selected-to-cart', $wrapper).removeClass('disabled');

            if ($('.add-selected-to-wishlist', $wrapper).hasClass('disabled'))
                $('.add-selected-to-wishlist', $wrapper).removeClass('disabled');

        } else {
            if (!$('.add-selected-to-cart', $wrapper).hasClass('disabled'))
                $('.add-selected-to-cart', $wrapper).addClass('disabled');

            if (!$('.add-selected-to-wishlist', $wrapper).hasClass('disabled'))
                $('.add-selected-to-wishlist', $wrapper).addClass('disabled');
        }
    };

    wrapper.multipleAddToCart = function () {
        var $selectedItems = $('[data-type="selectCheckbox"]:checked').closest('.shared-list-item');
        var selectedItemsArray = [];

        $.each($selectedItems, function (i, product) {
            var $product = $(product), data = {};

            if ($product.data('variantid')) {
                data = {
                    id: $product.data('productid'),
                    skuId: $product.data('variantid'),
                    path: $product.data('path'),
                    qty: stringToNumber($product.data('quantity'))
                };
                selectedItemsArray.push(data);
            }
        });

        Vendd.MessageBus.publishAsync(wrapper, new Vendd.Cart.Messages.MultipleAdd(selectedItemsArray));
    };

    wrapper.multipleAddToWishlist = function () {
        var $selectedItems = $('[data-type="selectCheckbox"]:checked').closest('.shared-list-item');
        var selectedItemsArray = [];

        $.each($selectedItems, function (i, product) {
            var $product = $(product), data = {};

            if ($product.data('variantid')) {
                data = {
                    id: $product.data('productid'),
                    skuId: $product.data('variantid'),
                    path: $product.data('path'),
                    qty: stringToNumber($product.data('quantity')),
                    extraAttributes: [],
                    bundleItems: [],
                    listId: 0,
                    currentListId: 0
                };
                selectedItemsArray.push(data);
            }
        });

        Vendd.MessageBus.publishAsync(wrapper, new Vendd.Wishlist.Messages.MultipleAdd(selectedItemsArray));
    };

    $wrapper.on('change', '[data-type="selectAllCheckbox"]', function () {
        if ($(this).is(':checked')) {
            $.each($('[data-type="selectCheckbox"]', $wrapper), function (index, checkbox) {
                if ($(checkbox).not(':disabled').length > 0) {
                    $(checkbox).prop('checked', true);
                    selectedItems = selectedItems + 1;
                }
            });
        } else {
            $('[data-type="selectCheckbox"]', $wrapper).prop('checked', false);
            selectedItems = 0;
        }

        wrapper.updateButtons();
    });

    $wrapper.on('change', '[data-type="selectCheckbox"]', function () {
        if ($(this).is(':checked')) {
            selectedItems++;

            if (selectedItems === itemsCount) {
                $('[data-type="selectAllCheckbox"]', $wrapper).prop('checked', true);
            }
        } else {
            selectedItems--;
            $('[data-type="selectAllCheckbox"]', $wrapper).prop('checked', false);
        }

        wrapper.updateButtons();
    });

    $wrapper.on('click', '.js-add-selected-to-cart', function (e) {
        e.preventDefault();

        if ($(this).hasClass('disabled'))
            return;

        if (selectedItems > 0)
            $fancyboxCartLink.trigger('click');
    });

    $wrapper.on('click', '.js-add-selected-to-wishlist', function (e) {
        e.preventDefault();

        if ($(this).hasClass('disabled'))
            return;

        if (selectedItems > 0)
            $fancyboxWishlistLink.trigger('click');
    });

    $('[data-click="cart-accept"]').on('click', function (e) {
        e.preventDefault();

        Vendd.MessageBus.publishAsync(wrapper, new Vendd.Cart.Messages.Clear());
        Vendd.MessageBus.subscribe(Vendd.Cart.Messages.ClearSuccess, wrapper, function (envelope) {
            wrapper.multipleAddToCart();
            $.fancybox.close();
        });
    });

    $('[data-click="cart-decline"]').on('click', function (e) {
        e.preventDefault();

        wrapper.multipleAddToCart();

        $.fancybox.close();
    });

    $('[data-click="wishlist-accept"]').on('click', function (e) {
        e.preventDefault();

        Vendd.MessageBus.publishAsync(wrapper, new Vendd.Wishlist.Messages.Clear());
        Vendd.MessageBus.subscribe(Vendd.Wishlist.Messages.ClearSuccess, wrapper, function (envelope) {
            wrapper.multipleAddToWishlist();
            $.fancybox.close();
        });
    });

    $('[data-click="wishlist-decline"]').on('click', function (e) {
        e.preventDefault();

        wrapper.multipleAddToWishlist();

        $.fancybox.close();
    });

});
